export default __webpack_public_path__ + "static/media/employee-manager.ce80dcbf.gif";